import ReactDOM from 'react-dom/client';
import { DEV_MODE } from './config.js';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import { MedicationApp } from './views/MedicationApp.jsx';
import { AuthGate } from './views/AuthGate.jsx';

// Up to 1.10 the app compiled itself on the phone and kept the result
// (~230 KB) in localStorage under these keys. Nothing reads them any more.
try { localStorage.removeItem('medCompiledKey'); localStorage.removeItem('medCompiledCode'); } catch (e) {}

// Render
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ErrorBoundary>{DEV_MODE ? <MedicationApp /> : <AuthGate />}</ErrorBoundary>);
